import axios from 'axios'
import OptionsTransformer from 'transformers/OptionsTransformer'

export default {
    getList() {
        return axios.get('unauthenticated/physician-groups?_fields=id,name,displayName,email,groupType', {
            transformResponse: [OptionsTransformer.transform('id', 'displayName')],
        })
    },
}
